import Promise from 'bluebird';
import {
  oDataTypeConfig,
  transformAssetId,
  namePropertyConfig,
} from './request-transformer-util';

export const transformRenameRequest = ({ assetId, folderAssetType, name }) => ({
  Asset: {
    '@odata.type': oDataTypeConfig[folderAssetType],
    Id: transformAssetId(assetId),
    [namePropertyConfig[folderAssetType]]: name,
  },
});

export const transformAltTextRequest = ({ assetId, folderAssetType, text }) => ({
  Asset: {
    '@odata.type': oDataTypeConfig[folderAssetType],
    Id: transformAssetId(assetId),
    AltText: text,
  },
});

const readAsDataUrlAsync = url => (
  fetch(url)
    .then(response => response.blob()) // Convert response to Blob
    .then(blob => new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = e => resolve(e.target.result);
      reader.onerror = e => reject(reader.error, e);

      // Scheduling the reading of the blob
      reader.readAsDataURL(blob);
    }))
);

const removeEncodingPrefix = (data) => {
  const base64 = 'base64,';
  const base64Index = data.indexOf(base64);

  return base64Index > -1
    ? data.substr(base64Index + base64.length)
    : data;
};

export const transformImageUrlToImageDataAsync = (imageUrl) => {
  const promise = readAsDataUrlAsync(imageUrl)
    .then(data => removeEncodingPrefix(data));
  return promise;
};
